import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import ReferralCreate from '../../../features/Referrals/ReferralCreate';
import { getPatient, createReferral } from '../../../actions/entities';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';

const mapStateToProps = ({ entities: { patients }, global: { auth } }) => ({
  patient: patients.previewed.patient,
  isFetching: patients.previewed.isFetching,
  canAddTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canAddTreatments),
  canAddReferrals: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canAddReferrals),
  canEditTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canEditTreatments),
  canEditReferrals: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canAddTreatments),
});

const mapDispatchToProps = dispatch => ({
  navigate: url => dispatch(push(url)),
  goBack: () => dispatch(goBack()),
  getPatientData: patientId => dispatch(getPatient(patientId)),
  createReferral: referralData => dispatch(createReferral(referralData)),
});

const ReferralCreatePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReferralCreate);

export default ReferralCreatePage;
